<template>
  <div v-show="visible && activated" class="fddform-pop-fixed">
    <div class="fddform-pop-box" :style="`width: ${width}px;`" :class="boxClass">
      <div class="fddform-pop-box-title">
        <span class="title"
          ><slot name="title">{{ title }}</slot></span
        >
        <a class="close" @click="handleClose"><span class="use-close"></span></a>
      </div>
      <div v-loading="loading" class="fddform-pop-box-bd">
        <slot></slot>
      </div>
    </div>
    <div class="fddform-pop-bg" @click="maskClose && handleClose()"></div>
  </div>
</template>
<script>
  import mount from '@/mixins/mount'

  export default {
    name: 'FddDialog',
    mixins: [mount],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '提示'
      },

      // 窗口 class
      boxClass: {
        type: String,
        default: ''
      },

      width: {
        type: [Number, String],
        default: 470
      },

      // 是否加载中
      loading: {
        type: Boolean,
        default: false
      },

      // 是否点击遮罩关闭
      maskClose: {
        type: Boolean,
        default: false
      },

      mount: {
        type: String,
        default: 'body'
      }
    },
    data() {
      return {}
    },
    methods: {
      handleClose() {
        this.$emit('update:visible', false)
        this.$emit('close')
      }
    }
  }
</script>
<style scoped>
  .use-close {
    display: inline-block;
    transform: scale(0.7);
  }
</style>
